import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../../store/modules/app';
import OpenOrderModifyDeliveryInfo from '../../../views/app/common/OpenOrderModifyDeliveryInfo';

class OpenOrderModifyDeliveryInfoContainer extends Component {
  render() {
    return <OpenOrderModifyDeliveryInfo {...this.props} />;
  }
}

const mapDispatchToProps = {
  getOrderDeliveryModifyData: appActions.getOrderDeliveryModifyData,
};

export default connect(null, mapDispatchToProps)(OpenOrderModifyDeliveryInfoContainer);
